// removed by extract-text-webpack-plugin
module.exports = {"action-container":"action-container","administrative-action":"administrative-action","approve":"approve","delete":"delete"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grids/ViewUsersGrid/subComponents/actions/Actions.scss
// module id = 5373
// module chunks = 1